function setOrReplaceIn(items, item) {
	const existingItem = items.find(({ id }) => id === item.id);

	if (existingItem) {
		const idx = items.indexOf(existingItem);
		items.splice(idx, 1, item)
	} else {
		items.push(item);
	}
}

export {
	setOrReplaceIn
}